module.exports = __webpack_public_path__ + "static/media/areamap6.1af9dfc5.svg";